exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mt-2[data-v-503821b8]{margin-top:15px}.mt-4[data-v-503821b8]{margin-top:30px}li[data-v-503821b8]{margin-top:15px;font-size:.875rem!important}", ""]);

// exports
